module.exports = __webpack_public_path__ + "static/media/chevronRight.0649b746.svg";